import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export type UpdateUserProfileParams = {
  user_id: string;
  first_name: string;
  last_name: string;
  gender?: string;
  phone_number: string;
  city_town?: string;
  postcode: string;
};

const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ user_id, ...profile }: UpdateUserProfileParams) => {
    const { data, error } = await supabaseClient
      .from('users')
      .update({
        first_name: profile.first_name,
        last_name: profile.last_name,
        gender: profile.gender || null,
        phone_number: profile.phone_number,
        city_town: profile.city_town || null,
        postcode: profile.postcode,
      })
      .eq('id', user_id)
      .select()
      .single();

    if (error) {
      console.error('Error updating user profile:', error);
      throw new Error(error.message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['current-user', variables.user_id] });
    },
  });
};

export default useUpdateUserProfile;
